import UserRoles from "../Constant/UserRoles";
export const FORM_MODE = {
  ADD: "Add",
  UPDATE: "Update",
  APPROVE: "Approve",
};
const LABELS = {
  districtName: "District Name :",
  talukaName: "Taluka Name :",
  governingbodyName : "Governing Body Name :",
  corporationName : "Corporation Name :",
  phcName: "PHC Name :", 
  phcName: "PHC Name :", 
  subcenterName: "Subcenter Name :",
  areaType: "Area Type :",
  programName: "Program Name :",
  documentProof: "Document Proof :",
  lgbName: "LGB Name :",
  uphcName: "UPHC Name :",
  subarea: "Sub Area Name : "
};
export const FORM_CONFIG = {
  districtFields: {
    title: "District",
    initialValues: {
      stateId: 1,
      stateName: "Maharashtra",
      districtCode: "",
      districtName: "",
      attachedDoc: "",
      remarks: "",
    },

    fields: [
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        label: "State :",
        name: "stateId",
        optionName: "stateName",
        type: "dropdown",
        options: "stateOptions",
        disabled: true,
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        translate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "districtCode",
        label: "District Code :",
        component: "input",
        type: "text",
        disabled: false,
        required: true,
        filter: false,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "districtName",
        label: LABELS.districtName,
        component: "input",
        type: "text",
        placeholder: "Enter English text",
        disabled: false,
        required: true,
        translate: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },

      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        required: true,
        translate: false,
        type: "file",
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },
  talukaFields: {
    title: "Taluka",
    initialValues: {
      stateId: 1,
      stateName: "Maharashtra",
      districtId: 0,
      districtName: "",
      talukaCode: "",
      talukaName: "",
      attachedDoc: "", 
      remarks: "",
    },

    fields: [
      {
        isShowRole: [],
        name: "stateId",
        optionName: "stateName",
        label: "State :",
        type: "dropdown",
        options: "stateOptions",
        disabled: true,
        required: true,
        translate: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "districtId",
        optionName: "districtName",
        label: LABELS.districtName,
        component: "input",
        type: "dropdown",
        options: "districtOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "talukaCode",
        label: "Taluka Code :",
        component: "input",
        type: "text",
        required: true,
        translate: false,
        disabled: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Taluka Codes",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "talukaName",
        label: LABELS.talukaName,
        component: "input",
        type: "text",
        translate: true,
        required: true,
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Taluka Names",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        type: "file",
        translate: false,
        disabled: false,
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },
  governingbodyFields: {
    title: "Local Governing Body",
    initialValues: {
      areaId: 0,
      areaType: "",
      lgbIdCode: "",
      lgbName: "",
      attachedDoc: "", 
    },
    fields: [
      {
        isShowRole: [],
        name: "areaId",
        optionName: "areaType",
        label: LABELS.areaType,
        type: "dropdown",
        options: "areaTypeOptions",
        required: true,
        filter: false,
        translate: false,
        showFilterMenu: false,
        disabled: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Area Types",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "lgbIdCode",
        label: "LGB Code :",
        component: "input",
        required: true,
        type: "text",
        filter: true,
        placeholder: "LGB Code",
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "LGB Codes",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "lgbName",
        label: "LGB Name",
        component: "input",
        required: true,
        translate: true,
        type: "text",
        filter: true,
        placeholder: "LGB Name",
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "LGB Names",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        required: true,
        type: "file",
        filter: true,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },

  corporationFields: {
    title: "Corporation / Council",
    initialValues: {
      stateId: 1,
      corporation_coucil_name: "",
      corporation_council_code: "",
      stateName: "Maharashtra",
      districtId: 0,
      districtName: "",
      talukaId: 0,
      talukaName: "",
      areaId: 1,
      areaType: "Urban",
      lgbId: 0,
      lgbName: "",
      attachedDoc: "", //attachment: null,
    },
    fields: [
      {
        isShowRole: [],
        name: "stateId",
        optionName: "stateName",
        label: "State :",
        type: "dropdown",
        options: "stateOptions",
        disabled: true,
        required: true,
        translate: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "districtId",
        optionName: "districtName",
        label: LABELS.districtName,
        component: "input",
        type: "dropdown",
        options: "districtOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "areaId",
        optionName: "areaType",
        label: LABELS.areaType,
        type: "dropdown",
        options: "areaTypeOptions",
        type: "dropdown",
        disabled: true,
        filter: false,
        required: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "lgbId",
        optionName: "lgbName",
        label: LABELS.lgbName,
        type: "dropdown",
        options: "lgbOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        disabled: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        isShowRole: [],
        whenVisible: [
          {
            name: "lgbId",
            values: [1],
          },
        ],
        name: "talukaId",
        optionName: "talukaName",
        label: LABELS.talukaName,
        type: "dropdown",
        options: "talukaOptions",
        required: true,
        filter: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
        initialValue: 0,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "corporation_council_code",
        label: "Corporation/Council Code :",
        component: "input",
        required: true,
        type: "text",
        filter: true,
        placeholder: "Corporation Code",
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Corporation Codes",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "corporation_coucil_name",
        label: "Corporation/Council Name",
        component: "input",
        required: true,
        translate: true,
        type: "text",
        filter: true,
        placeholder: "Corporation Name",
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Corporation Names",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        required: true,
        type: "file",
        filter: true,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },
  roleFields: {
    title: "Role",
    initialValues: {
      roleCode: "",
      roleName: "",
      access_level_id: "",
      access_level_name: '',
      mapMenus: [],
      attachedDoc: "", //attachment: null,
      remarks: "",
    },
    fields: [
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "roleCode",
        label: "Role Code :",
        component: "input",
        type: "text",
        required: false,
        disabled: false,
        filter: false,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "roleName",
        label: "Role :",
        component: "input",
        type: "text",
        required: true,
        translate: true,
        disabled: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "mapMenus",
        label: "Map Menus :",
        type: "multiselect",
        options: "mapMenusOptions",
        component: "div",
        required: true,
        translate: false,
        disabled: false,
        filter: true,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "access_level_id",
        optionName: "access_level_name",
        label: "Access Level :",
        type: "dropdown",
        options: "accessLevelOptions",
        required: true,
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        type: "file",
        disabled: false,
        required: true,
        translate: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },
  userFields: {
    title: "User",
    initialValues: {
      firstName: "",
      lastName: "",
      mobileNo: "",
      email: "",
      designation: "",
      roleId: 0,
      roleName: "",
      stateId: 1,
      stateName: "Maharashtra",
      districtId: 0,
      districtName: "",
      lgbId: 0,
      lgbName: "",
      areaId: 0,
      areaType: "",
      talukaId: 0,
      talukaName: "",
      corporation_council_id:0,
      corporation_coucil_name:"",
      phcId: 0,
      phcName: "",
      attachedDoc: "",
      remarks: "",
      multidistrictId: []
    },
    fields: [
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "firstName",
        label: "First Name :",
        component: "input",
        type: "text",
        required: true,
        translate: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        disabled: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "lastName",
        label: "Last Name :",
        component: "input",
        type: "text",
        translate: true,
        required: true,
        filter: false,
        showFilterMenu: false,
        disabled: false,
        showWhenMultiUpdate: false,
      },

      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "mobileNo",
        label: "Contact No:",
        component: "input",
        type: "text",
        translate: false,
        required: true,
        disabled: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "email",
        label: "Email Id :",
        component: "input",
        type: "text",
        translate: false,
        required: true,
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "password",
        label: "Password :",
        component: "input",
        type: "password",
        translate: false,
        required: true,
        filter: false,
        showFilterMenu: false,
        disabled: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "confirmPassword",
        label: "Confirm Password :",
        component: "input",
        type: "password",
        translate: false,
        required: true,
        filter: false,
        showFilterMenu: false,
        disabled: false,
        showWhenMultiUpdate: false,
        confirmPasswordFieldName: "password",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "designation",
        label: "Designation :",
        component: "input",
        type: "text",
        translate: true,
        required: true,
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "roleId",
        optionName: "roleName",
        label: "Role :",
        type: "dropdown",
        options: "roleOptions",
        required: true,
        translate: false,
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.BCM,UserRoles.BFO,UserRoles.CAM,UserRoles.CPM,
          UserRoles.DAM,UserRoles.DCM,UserRoles.DHO,UserRoles.JOINTDIRECTOR,
          UserRoles.MOH,UserRoles.PHCMO,UserRoles.STATECOMMISSIONER,
          UserRoles.THO,UserRoles.UPHCMO,UserRoles.STATEASHAPO,UserRoles.SUPERADMIN],
        name: "stateId",
        optionName: "stateName",
        label: "State :",
        type: "dropdown",
        options: "stateOptions",
        disabled: true,
        translate: false,
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [],
        whenVisible: [
          {
            name: "roleName",
            values: [
              UserRoles.DISTRICTHEAD,
              UserRoles.BLOCKHEAD,
              UserRoles.PHCHEAD,
              UserRoles.UPHCHEAD,
              UserRoles.BCM,UserRoles.BFO,UserRoles.CAM,UserRoles.CPM,
              UserRoles.DAM,UserRoles.DCM,UserRoles.DHO,
              UserRoles.MOH,UserRoles.PHCMO,
              UserRoles.THO,UserRoles.UPHCMO,
              UserRoles.BLOCKACCOUNTANT,
            ],
          },
        ],
        name: "districtId",
        optionName: "districtName",
        label: LABELS.districtName,
        type: "dropdown",
        options: "districtOptions",
        required: true,
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [],
        whenVisible: [
          {
            name: "roleName",
            values: [
              UserRoles.MULTIDISTRICT,
            ],
          },
        ],
        name: "multidistrictId",
        optionName: "districtName",
        label: LABELS.districtName,
        type: "multiselect",
        options: "districtOptions",
        required: true,
        filter: true,
        disabled: false,
        showFilterMenu: true,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [],
        whenVisible: [
          {
            name: "roleName",
            values: [UserRoles.UPHCHEAD,UserRoles.UPHCMO,UserRoles.CAM,UserRoles.CPM, UserRoles.MOH],
          },
        ],
        name: "lgbId",
        optionName: "lgbName",
        label: LABELS.lgbName,
        type: "dropdown",
        options: "lgbOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        disabled: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [],
        whenVisible: [
          {
            name: "roleName",
            values: [UserRoles.BLOCKHEAD, UserRoles.PHCHEAD, UserRoles.THO,UserRoles.BCM,UserRoles.BFO,
              UserRoles.PHCMO, UserRoles.UPHCHEAD,UserRoles.UPHCMO,UserRoles.BLOCKACCOUNTANT
            ],
          },
        ],
        name: "talukaId",
        optionName: "talukaName",
        label: LABELS.talukaName,
        type: "dropdown",
        options: "talukaOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        disabled: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [],
        whenVisible: [{ name: "roleName", values: [UserRoles.PHCHEAD,UserRoles.PHCMO, UserRoles.UPHCHEAD,UserRoles.UPHCMO] }],
        name: "phcId",
        optionName: "phcName",
        label: "PHC Name :",
        type: "dropdown",
        options: "phcOptions",
        required: true,
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.CAM,UserRoles.CPM,UserRoles.MOH],
        whenVisible: [{ name: "roleName", values: [UserRoles.CAM,UserRoles.CPM,UserRoles.MOH] }],
        name: "corporation_council_id",
        optionName: "corporation_coucil_name",
        label: LABELS.corporationName,
        type: "dropdown",
        options: "corporationOptions",
        required: true,
        disabled: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        whenVisible: [
          {
            name: "roleName",
            values: [UserRoles.PHCHEAD, UserRoles.UPHCHEAD],
          },
        ],
        name: "areaId",
        optionName: "areaType",
        label: LABELS.areaType,
        type: "dropdown",
        options: "areaTypeOptions",
        type: "dropdown",
        disabled: false,
        filter: false,
        required: true,
        showFilterMenu: false,
        showWhenMultiUpdate: false
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        type: "file",
        translate: false,
        required: true,
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },
  bankFields: {
    title: "Bank Master",
    fields: [],
  },
  trainingFields: {
    title: "Training",
    initialValues: {
      trainingName: "",
      days: "",
      attachedDoc: "",
      remarks: "",
    },
    fields: [
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "trainingName",
        label: "Training Name :",
        component: "input",
        type: "text",
        disabled: false,
        required: true,
        translate: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "days",
        label: "Days :",
        component: "input",
        type: "text",
        required: true,
        translate: false,
        disabled: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        type: "file",
        disabled: false,
        required: true,
        filter: false,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },

  trainingCalendarFields: {
    title: "Training Calendar",
    initialValues: {
      trainingId: 0,
      trainingName: "",
      days: "",
      startDate: "",
      districtId: 0,
      districtName: "",
      talukaId: 0,
      talukaName: "",
      phcId: 0,
      phcName: "",
      subcenterId: 0,
      subcenterName: "",
      villageId: 0,
      villageName: "",
      facultyId: 0,
      facultyName: "",
      attachedDoc: "",
      remarks: "",
    },
    fields: [
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "trainingId",
        optionName: "trainingName",
        label: "Training Name :",
        type: "dropdown",
        options: "trainingOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Training Names",
        containsValues: [{ name: "days", value: "days", initialValue: "" }],
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "days",
        label: "Days :",
        component: "input",
        type: "text",
        disabled: true,
        required: true,
        filter: false,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Days",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "startDate",
        label: "Start Date :",
        component: "input",
        type: "calendar",
        disabled: false,
        required: true,
        filter: false,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Start Dates",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "districtId",
        optionName: "districtName",
        label: LABELS.districtName,
        type: "dropdown",
        options: "districtOptions",
        required: true,
        filter: false,
        disabled: false,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "talukaId",
        optionName: "talukaName",
        label: LABELS.talukaName,
        type: "dropdown",
        options: "talukaOptions",
        required: true,
        disabled: false,
        filter: false,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "phcId",
        optionName: "phcName",
        label: LABELS.phcName,
        type: "dropdown",
        options: "phcOptions",
        required: true,
        disabled: false,
        filter: false,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "subcenterId",
        optionName: "subcenterName",
        label: LABELS.subcenterName,
        type: "dropdown",
        options: "subcenterOptions",
        required: false,
        disabled: false,
        filter: false,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "villageId",
        optionName: "villageName",
        label: "Village Name :",
        type: "dropdown",
        options: "villageOptions",
        disabled: false,
        required: false,
        translate: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "facultyId",
        optionName: "facultyName",
        label: "Faculty Name :",
        type: "dropdown",
        options: "facultyOptions",
        required: true,
        filter: false,
        disabled: false,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Faculties",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        type: "file",
        required: true,
        filter: false,
        disabled: false,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },
  facultyFields: {
    title: "Faculty",
    initialValues: {
      stateId: 1,
      stateName: "Maharashtra",
      districtId: 0,
      districtName: "",
      facultyCode: "",
      facultyName: "",
      attachedDoc: "",
      remarks: "",
    },
    fields: [
      {
        isShowRole: [],
        name: "stateId",
        optionName: "stateName",
        label: "State :",
        type: "dropdown",
        options: "stateOptions",
        required: true,
        filter: false,
        translate: false,
        disabled: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "districtId",
        optionName: "districtName",
        label: LABELS.districtName,
        type: "dropdown",
        options: "districtOptions",
        required: true,
        translate: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "facultyCode",
        label: "Faculty Code :",
        component: "input",
        type: "text",
        required: false,
        translate: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Faculty Codes",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "facultyName",
        label: "Faculty Name :",
        component: "input",
        type: "text",
        translate: true,
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Faculty Names",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        type: "file",
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        disabled: false,
      },
    ],
  },

  programFields: {
    title: "Program",
    initialValues: {
      areaId: 0,
      areaTypeName: "",
      programCode: "",
      programName: "",
      attachedDoc: "",
      remarks: "",
    },
    fields: [
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "areaId",
        optionName: "areaTypeName",
        label: LABELS.areaType,
        component: "input",
        type: "dropdown",
        options: "areaTypeOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "programCode",
        label: "Program Code:",
        component: "input",
        type: "text",
        translate: false,
        required: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        disabled: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "programName",
        label: LABELS.programName,
        component: "input",
        type: "text",
        required: true,
        translate: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        disabled: false,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        type: "file",
        required: true,
        translate: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        disabled: false,
      },
    ],
  },
  schemeFields: {
    title: "Scheme",
    initialValues: {
      programId: 0,
      programName: "",
      areaId: 0,
      areaType: "",
      schemeCode: "",
      schemeName: "",
      attachedDoc: "",
      remarks: "",
    },
    fields: [
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "programId",
        optionName: "programName",
        label: LABELS.programName,
        type: "dropdown",
        options: "programOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
        disabled: false,
        containsValues: [{ name: "areaId", value: "areaId", initialValue: 0 }],
      },
      {
        isShowRole: [],
        name: "areaId",
        optionName: "areaType",
        label: LABELS.areaType,
        type: "dropdown",
        options: "areaTypeOptions",
        required: true,
        filter: false,
        translate: false,
        showFilterMenu: false,
        disabled: true,
        showWhenMultiUpdate: true,
      },

      // {
      //   isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
      //   name: 'areaType',
      //   label: LABELS.areaType,
      //   component: 'input',
      //   type: 'text',
      //   translate: false,
      //   required: false,
      //   filter: false,
      //   disabled: true,
      //   showFilterMenu: false,
      //   showWhenMultiUpdate: true,
      // },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "schemeCode",
        label: "Scheme Code :",
        component: "input",
        type: "text",
        required: false,
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Scheme Codes",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "schemeName",
        label: "Scheme Name :",
        component: "input",
        type: "text",
        translate: true,
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Scheme Names",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        type: "file",
        translate: false,
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },
  activityFields: {
    title: "Activity",
    initialValues: {
      programId: 0,
      programName: "",
      areaId: 0,
      areaType: "",
      schemeId: 0,
      schemeName: "",
      activityCode: "",
      activityName: "",
      paymentRate: "",
      attachedDoc: "",
      remarks: "",
    },
    fields: [
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "programId",
        optionName: "programName",
        label: LABELS.programName,
        type: "dropdown",
        options: "programOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
        disabled: false,
        containsValues: [{ name: "areaId", value: "areaId", initialValue: 0 }],
      },
      {
        isShowRole: [],
        name: "areaId",
        optionName: "areaType",
        label: LABELS.areaType,
        type: "dropdown",
        options: "areaTypeOptions",
        required: true,
        filter: false,
        translate: false,
        showFilterMenu: false,
        disabled: true,
        showWhenMultiUpdate: true,
      },

      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "schemeId",
        optionName: "schemeName",
        label: "Scheme Name :",
        type: "dropdown",
        options: "schemeOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "activityCode",
        label: "Activity Code :",
        component: "input",
        type: "text",
        required: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Activity Codes",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "activityName",
        label: "Activity Name :",
        component: "input",
        type: "text",
        translate: true,
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Activity Names",
      },
       {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "incentiveId",
        label: "Incentive For :",
        type: "dropdown",
        options:"incentiveOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "incentiveId",
        label: "Incentive For :",
        type: "dropdown",
        options: [
          { label: "State", value: "state" },
          { label: "Central", value: "central" },
        ],
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "paymentRate",
        label: "Payment Rate :",
        component: "input",
        type: "text",
        required: true,
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Payment Rates",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        type: "file",
        required: true,
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },
  areaFields: {
    title: "Area",
    fields: [
      {
        isShowRole: [],
        label: "Area Code :",
        name: "areaCode",
        component: "input",
        type: "text",
        filter: true,
        required: true,
        showFilterMenu: false,
      },
      {
        isShowRole: [],
        name: "areaType",
        label: "Area Type",
        component: "input",
        type: "text",
        required: true,
        filter: true,
        showFilterMenu: false,
      },
      {
        isShowRole: [],
        name: "areaCategory",
        label: "Area Category",
        component: "input",
        type: "text",
        required: true,
        filter: true,
        showFilterMenu: false,
      },

      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        required: true,
        type: "file",
        filter: true,
        showFilterMenu: false,
      },
    ],
  },

  phcFields: {
    title: "PHC",
    initialValues: {
      stateId: 1,
      stateName: "Maharashtra",
      districtId: 0,
      districtName: "",
      talukaId: 0,
      talukaName: "",
      areaCategoryId: 0,
      areaCategory: "",
      areaId: 2,
      areaType: "Rural",
      phcCode: "",
      phcName: "",
      attachedDoc: "", //attachment: null,
      remarks: "",
    },
    fields: [
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        label: "State :",
        name: "stateId",
        optionName: "stateName",
        type: "dropdown",
        options: "stateOptions",
        disabled: true,
        filter: false,
        required: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "districtId",
        optionName: "districtName",
        label: LABELS.districtName,
        type: "dropdown",
        options: "districtOptions",
        required: true,
        disabled: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "talukaId",
        optionName: "talukaName",
        label: LABELS.talukaName,
        type: "dropdown",
        options: "talukaOptions",
        required: true,
        filter: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "areaId",
        optionName: "areaType",
        label: LABELS.areaType,
        type: "dropdown",
        options: "areaTypeOptions",
        type: "dropdown",
        disabled: true,
        filter: false,
        required: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true
      },
      {
        isShowRole: [],
        whenVisible: [
          {
            name: "areaId",
            // make sure values will be id of rural area type
            values: [2],
          },
        ],
        name: "areaCategoryId",
        optionName: "areaCategory",
        label: "Area Category :",
        type: "dropdown",
        options: "areaCategoryOptions",
        required: true,
        filter: false,
        translate: false,
        showFilterMenu: false,
        disabled: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Area Categories",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "phcCode",
        label: "PHC Code :",
        component: "input",
        required: true,
        type: "text",
        filter: true,
        placeholder: "PHC Code",
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "PHC Codes",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "phcName",
        label: LABELS.phcName,
        component: "input",
        required: true,
        translate: true,
        type: "text",
        filter: true,
        placeholder: "PHC Name",
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "PHC Names",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        required: true,
        type: "file",
        filter: true,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },

  uphcFields: {
    title: "UPHC",
    initialValues: {
      stateId: 1,
      stateName: "Maharashtra",
      districtId: 0,
      districtName: "",
      talukaId: 0,
      talukaName: "",
      lgbId:0,
      lgbName:"",
      corporation_council_id:0,
      corporation_coucil_name:"",
      areaId: 1,
      areaType: "Urban",
      phcCode: "",
      phcName: "",
      attachedDoc: "", //attachment: null,
      remarks: "",
    },
    fields: [
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        label: "State :",
        name: "stateId",
        optionName: "stateName",
        type: "dropdown",
        options: "stateOptions",
        disabled: true,
        filter: false,
        required: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "districtId",
        optionName: "districtName",
        label: LABELS.districtName,
        type: "dropdown",
        options: "districtOptions",
        required: true,
        disabled: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "areaId",
        optionName: "areaType",
        label: LABELS.areaType,
        type: "dropdown",
        options: "areaTypeOptions",
        type: "dropdown",
        disabled: true,
        filter: false,
        required: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "lgbId",
        optionName: "lgbName",
        label: LABELS.lgbName,
        type: "dropdown",
        options: "lgbOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        disabled: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        whenVisible: [
          {
            name: "lgbId",
            values: [1],
          },
        ],
        name: "talukaId",
        optionName: "talukaName",
        label: LABELS.talukaName,
        type: "dropdown",
        options: "talukaOptions",
        required: true,
        filter: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "corporation_council_id",
        optionName: "corporation_coucil_name",
        label: LABELS.corporationName,
        type: "dropdown",
        options: "corporationOptions",
        required: true,
        disabled: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "phcCode",
        label: "PHC Code :",
        component: "input",
        required: true,
        type: "text",
        filter: true,
        placeholder: "PHC Code",
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "PHC Codes",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "phcName",
        label: LABELS.phcName,
        component: "input",
        required: true,
        translate: true,
        type: "text",
        filter: true,
        placeholder: "PHC Name",
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "PHC Names",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        required: true,
        type: "file",
        filter: true,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },

  subcenterFields: {
    title: "Subcenter",
    initialValues: {
      stateId: 1,
      stateName: "Maharashtra",
      districtId: 0,
      districtName: "",
      talukaId: 0,
      talukaName: "",
      phcId: 0,
      phcName: "",
      subcenterCode: "",
      subcenterName: "",
      attachedDoc: "", //attachment: null,
      remarks: "",
    },
    fields: [
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        label: "State :",
        name: "stateId",
        optionName: "stateName",
        type: "dropdown",
        options: "stateOptions",
        disabled: true,
        filter: false,
        required: true,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "districtId",
        optionName: "districtName",
        label: LABELS.districtName,
        type: "dropdown",
        options: "districtOptions",
        translate: false,
        required: true,
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "talukaId",
        optionName: "talukaName",
        label: LABELS.talukaName,
        type: "dropdown",
        options: "talukaOptions",
        required: true,
        translate: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "phcId",
        optionName: "phcName",
        label: LABELS.phcName,
        required: true,
        type: "dropdown",
        options: "phcOptions",
        translate: false,
        filter: false,
        showFilterMenu: false,
        disabled: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "subcenterCode",
        label: "Subcenter Code :",
        component: "input",
        type: "text",
        required: true,
        translate: false,
        filter: false,
        disabled: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Subcenter Codes",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "subcenterName",
        label: LABELS.subcenterName,
        component: "input",
        type: "text",
        disabled: false,
        required: true,
        translate: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Subcenter Names",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        type: "file",
        required: true,
        filter: false,
        disabled: false,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },

  villageFields: {
    title: "Village",
    initialValues: {
      stateId: 1,
      stateName: "Maharashtra",
      districtId: 0,
      talukaId: 0,
      phcId: 0,
      subcenterId: 0,
      villageCode: "",
      villageName: "",
      attachedDoc: "",
      remarks: "",
    },

    fields: [
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        label: "State :",
        name: "stateId",
        optionName: "stateName",
        type: "dropdown",
        options: "stateOptions",
        disabled: true,
        filter: false,
        required: true,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "districtId",
        optionName: "districtName",
        label: LABELS.districtName,
        type: "dropdown",
        options: "districtOptions",
        required: true,
        translate: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "talukaId",
        optionName: "talukaName",
        label: LABELS.talukaName,
        type: "dropdown",
        options: "talukaOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        translate: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "phcId",
        optionName: "phcName",
        label: LABELS.phcName,
        required: true,
        type: "dropdown",
        options: "phcOptions",
        filter: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "subcenterId",
        optionName: "subcenterName",
        label: LABELS.subcenterName,
        required: true,
        type: "dropdown",
        options: "subcenterOptions",
        filter: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "villageCode",
        label: "Village Code :",
        component: "input",
        type: "text",
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Village Codes",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "villageName",
        label: "Village Name :",
        component: "input",
        type: "text",
        translate: true,
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Village Names",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        type: "file",
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },
  subareaFields: {
    title: "Sub Area",
    initialValues: {
      stateId: 1,
      stateName: "Maharashtra",
      districtId: 0,
      talukaId: 0,
      phcId: 0,
      areaId: 1,
      areaType: "Urban",
      subcenterId: 0,
      villageCode: "",
      villageName: "",
      attachedDoc: "",
      remarks: "",
    },

    fields: [
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        label: "State :",
        name: "stateId",
        optionName: "stateName",
        type: "dropdown",
        options: "stateOptions",
        disabled: true,
        filter: false,
        required: true,
        translate: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "districtId",
        optionName: "districtName",
        label: LABELS.districtName,
        type: "dropdown",
        options: "districtOptions",
        required: true,
        translate: false,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "areaId",
        optionName: "areaType",
        label: LABELS.areaType,
        type: "dropdown",
        options: "areaTypeOptions",
        type: "dropdown",
        disabled: true,
        filter: false,
        required: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        whenVisible: [
          {
            name: "areaId",
            values: [1],
          },
        ],
        name: "lgbId",
        optionName: "lgbName",
        label: LABELS.lgbName,
        type: "dropdown",
        options: "lgbOptions",
        required: true,
        filter: false,
        showFilterMenu: false,
        disabled: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        whenVisible: [
          {
            name: "lgbId",
            values: [1],
          },
        ],
        name: "talukaId",
        optionName: "talukaName",
        label: LABELS.talukaName,
        type: "dropdown",
        options: "talukaOptions",
        required: true,
        filter: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "phcId",
        optionName: "phcName",
        label: LABELS.uphcName,
        required: true,
        type: "dropdown",
        options: "phcOptions",
        filter: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        whenVisible: [
          {
            name: "areaId",
            values: [2],
          },
        ],
        name: "subcenterId",
        optionName: "subcenterName",
        label: LABELS.subcenterName,
        required: true,
        type: "dropdown",
        options: "subcenterOptions",
        filter: true,
        showFilterMenu: false,
        showWhenMultiUpdate: true,
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "villageCode",
        label: "Sub Area Code :",
        component: "input",
        type: "text",
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Village Codes",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "villageName",
        label: "Sub Area Name :",
        component: "input",
        type: "text",
        translate: true,
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
        pluralLabel: "Village Names",
      },
      {
        isShowRole: [UserRoles.ADMIN, UserRoles.SUPERADMIN],
        name: "attachedDoc",
        label: LABELS.documentProof,
        component: "input",
        type: "file",
        required: true,
        filter: false,
        showFilterMenu: false,
        showWhenMultiUpdate: false,
      },
    ],
  },
};
